import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  MenuItem,
  Menu,
  Checkbox,
  ListItemText,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Pagination,
  PaginationItem,
  FormControl,
  InputLabel,
  Select,
  CircularProgress,
} from "@mui/material";
import {
  PrimaryTypography,
  StyledTypography,
  StyledSecondaryTypography,
  ErrorTypography,
  StyledOutlinedInput,
} from "../../Theme";
import { ReactComponent as BackArrow } from "../../Icons/BorderBackArrow.svg";
import { useSelector, useDispatch } from "react-redux";
import axiosInstance from "../../Redux/AxiosInstance";
import { PostLoaderModal } from "../../CommonComponents/modal";
import { showToast } from "../../CommonComponents/Toaster";
import { ReactComponent as NumberInputIcon } from "../../Icons/NumberInputIcon.svg";
import { ReactComponent as PreviousIcon } from "../../Icons/Previous.svg";
import { ReactComponent as NextIcon } from "../../Icons/Next.svg";
import { ReactComponent as SearchIcon } from "../../Icons/Search.svg";
import { getAllBuildingByProperty } from "../../Redux/Feature/PropertyDetails/propertyDetailsSlice";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

const CreateGroup = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });
  const [formDataErrors, setFormDataErrors] = useState({});
  const [residentsData, setResidentsData] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  let { buildingList, propertyId } = useSelector(
    (state) => state.PropertyDetails
  );
  const navigate = useNavigate();
  const [selectedResidents, setSelectedResidents] = useState([]);
  console.log(selectedResidents, "selectedResidents");
  const [selectedResidentList, setSelectedResidentList] = useState([]);
  console.log(selectedResidentList, "selectedResidentList");
  const [levelData, setLevelData] = useState([]);
  const [selectedBuildings, setSelectedBuildings] = useState([]);
  const [selectedLevels, setSelectedLevels] = useState([]);
  const [showAnchorEl, setshowAnchorEl] = useState(null);
  const showOpen = Boolean(showAnchorEl);
  const [rowsPerPage, setRowsPerPage] = useState("20");
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState({});
  const [searchData, setSearchData] = useState("");
  const [postLoader, SetPostLoader] = useState(false);

  useEffect(() => {
    dispatch(getAllBuildingByProperty(propertyId));
  }, []);

  useEffect(() => {
    if (id) {
      SetPostLoader(true);
      axiosInstance
        .get(
          `${process.env.REACT_APP_API_URL}invoice-recurring/${id}/property/${propertyId}`
        )
        .then((res) => {
          if (res.data?.success) {
            const data = res.data?.data;
            setFormData({
              name: data?.title || "",
              description: data?.description || "",
            });

            // 🔹 Normalize recurring residents to match Create flow structure
            const recurringResidents = (data?.recurring_residents || []).map(
              (r) => ({
                id: r.id, // keep original id if needed
                user_id: r.resident_id,
                building_id: r.property_building_id,
                level_id: r.building_level_id,
                unit_id: r.building_unit_id,
                user_details: {
                  name: r.resident_name,
                  email: r.resident_email || "-", // if backend doesn't send email, handle fallback
                },
              })
            );

            setSelectedResidentList(recurringResidents);
            setSelectedResidents(recurringResidents.map((r) => r.user_id));
          }
        })
        .catch(() => {
          showToast("Something went wrong. Please try again later", "error");
        })
        .finally(() => {
          SetPostLoader(false);
        });
    }
  }, [id]);

  useEffect(() => {
    if (selectedBuildings.length > 0) {
      setSelectedLevels([]);
      const filteredBuildings = buildingList?.data?.property_buildings?.filter(
        (building) => selectedBuildings.includes(building.id)
      );
      const levels =
        filteredBuildings
          ?.flatMap((building) => building.level)
          ?.map((level) => ({ id: level.id, name: level.level })) || [];

      setLevelData(levels);
    } else {
      setLevelData([]);
      setSelectedLevels([]);
    }
  }, [selectedBuildings]);

  useEffect(() => {
    getAllResidentData();
  }, [currentPage, rowsPerPage, searchData, selectedBuildings, selectedLevels]);

  const getAllResidentData = async () => {
    let buildingIds = selectedBuildings?.map((data) => data).join(",");
    let leveIds = selectedLevels?.map((data) => data).join(",");
    setPageLoading(true);
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}onboard/property/${propertyId}/resident_onboard?page=${currentPage}&record_count=${rowsPerPage}&building_id=${buildingIds}&level_id=${leveIds}&search=${searchData}`
      )
      .then((res) => {
        setPaginationData(res?.data?.data?.pagination_details);
        setResidentsData(res?.data?.data?.resident_onboard);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setPageLoading(false);
      });
  };

  const handleAllResidentCheck = (event) => {
    setFormDataErrors({ ...formDataErrors, residents: "" });
    if (event.target.checked) {
      const allUserIds = residentsData.map((val) => val.user_id);

      setSelectedResidents((prev) => {
        const uniqueIds = Array.from(new Set([...prev, ...allUserIds]));
        return uniqueIds;
      });

      setSelectedResidentList((prev) => {
        const newResidents = residentsData.filter(
          (resident) => !prev.some((p) => p.user_id === resident.user_id)
        );
        return [...prev, ...newResidents];
      });
    } else {
      const currentPageIds = residentsData.map((val) => val.user_id);
      setSelectedResidents((prev) =>
        prev.filter((id) => !currentPageIds.includes(id))
      );
      setSelectedResidentList((prev) =>
        prev.filter((resident) => !currentPageIds.includes(resident.user_id))
      );
    }
  };
  const areAllCurrentPageSelected =
    residentsData.length > 0 &&
    residentsData.every((p) => selectedResidents.includes(p.user_id));

  const handleResidentSelect = (resident) => {
    setFormDataErrors({ ...formDataErrors, residents: "" });
    const isSelected = selectedResidents.includes(resident.user_id);

    if (isSelected) {
      setSelectedResidents((prev) =>
        prev.filter((id) => id !== resident.user_id)
      );
      setSelectedResidentList((prev) =>
        prev.filter((r) => r.user_id !== resident.user_id)
      );
    } else {
      setSelectedResidents((prev) => [...prev, resident.user_id]);
      setSelectedResidentList((prev) => [...prev, resident]);
    }
  };

  const handleRemoveResident = (userId) => {
    setSelectedResidents((prev) => prev.filter((id) => id !== userId));
    setSelectedResidentList((prev) => prev.filter((r) => r.user_id !== userId));
  };

  const handleRemoveAllResidents = () => {
    setSelectedResidents([]);
    setSelectedResidentList([]);
  };

  // 🔹 Validation before submit
  const validateForm = () => {
    let errors = {};
    if (!formData.name.trim()) errors.name = "Group name is required";
    if (!formData.description.trim())
      errors.description = "Group description is required";
    if (selectedResidentList.length === 0)
      errors.residents = "At least one resident must be selected";

    setFormDataErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = () => {
    if (!validateForm()) return; // 🔹 stop if validation fails
    let ids = selectedResidentList.map((data) => ({
      resident_id: data.user_id,
      property_building_id: data.building_id,
      building_level_id: data.level_id,
      building_unit_id: data.unit_id,
    }));

    if (id) {
      SetPostLoader(true);
      axiosInstance
        .post(
          `${process.env.REACT_APP_API_URL}invoice-recurring/${id}/property/${propertyId}`,
          {
            title: formData.name,
            description: formData.description,
            residents: ids,
          }
        )
        .then((res) => {
          if (res.data?.success) {
            SetPostLoader(false);
            showToast(res.data?.message);
            navigate("/group-list");
          }
        })
        .catch(() => {
          SetPostLoader(false);
          showToast("Something went wrong. Please try again later", "error");
        })
        .finally(() => {
          SetPostLoader(false);
        });
    } else {
      SetPostLoader(true);
      axiosInstance
        .post(
          `${process.env.REACT_APP_API_URL}invoice-recurring/${propertyId}`,
          {
            title: formData.name,
            description: formData.description,
            residents: ids,
          }
        )
        .then((res) => {
          if (res.data?.success) {
            SetPostLoader(false);
            showToast(res.data?.message);
            navigate("/group-list");
          }
        })
        .catch(() => {
          SetPostLoader(false);
          showToast("Something went wrong. Please try again later", "error");
        })
        .finally(() => {
          SetPostLoader(false);
        });
    }
  };

  return (
    <>
      {postLoader && <PostLoaderModal />}
      <Box sx={{ padding: "0 20px", maxWidth: "100%", margin: "0 auto" }}>
        <Box>
          <BackArrow
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/group-list")}
          />
          <PrimaryTypography sx={{ marginTop: "10px" }}>
            {id ? "Edit Group" : "Add Group"}
          </PrimaryTypography>
          <StyledSecondaryTypography>
            {id
              ? "Update the resident group details."
              : "Create a new resident group to generate group invoices."}
          </StyledSecondaryTypography>
        </Box>
        <Box
          sx={{
            backgroundColor: "#FFFFFF",
            borderRadius: "6px",
            marginTop: "10px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box sx={{ padding: "15px 20px 15px 20px", width: "45%" }}>
              <Box display={"flex"} justifyContent={"space-between"}>
                <StyledTypography>Group Name</StyledTypography>
              </Box>
              <TextField
                name="name"
                inputProps={{ maxLength: 50 }}
                InputProps={{ disableUnderline: true }}
                fullWidth
                placeholder="Enter name"
                sx={{
                  "& .MuiInputBase-root": {
                    color: formDataErrors?.name ? "#912018" : "#111927",
                  },
                  backgroundColor: formDataErrors?.name
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                value={formData.name}
                onChange={(e) => {
                  setFormData({ ...formData, name: e.target.value });
                  setFormDataErrors({ ...formDataErrors, name: "" });
                }}
                error={!!formDataErrors.name}
              />
              <ErrorTypography>{formDataErrors?.name}</ErrorTypography>
            </Box>

            <Box sx={{ padding: "15px 20px 15px 20px", width: "45%" }}>
              <Box display={"flex"} justifyContent={"space-between"}>
                <StyledTypography>Group Description</StyledTypography>
              </Box>
              <TextField
                name="description"
                multiline
                inputProps={{ maxLength: 100 }}
                InputProps={{ disableUnderline: true }}
                fullWidth
                placeholder="Enter description"
                sx={{
                  "& .MuiInputBase-root": {
                    color: formDataErrors?.description ? "#912018" : "#111927",
                  },
                  backgroundColor: formDataErrors?.description
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                value={formData.description}
                error={!!formDataErrors.description}
                onChange={(e) => {
                  setFormData({ ...formData, description: e.target.value });
                  setFormDataErrors({ ...formDataErrors, description: "" });
                }}
              />
              <ErrorTypography>{formDataErrors?.description}</ErrorTypography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            backgroundColor: "#FFFFFF",
            borderRadius: "6px 6px 0px 0px",
            marginTop: "10px",
            padding: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <StyledOutlinedInput
            sx={{ width: "400px" }}
            placeholder="Search Residents"
            onChange={(e) => {
              setSearchData(e.target.value);
            }}
            startAdornment={<SearchIcon style={{ paddingRight: "5px" }} />}
          />

          <FormControl fullWidth>
            <InputLabel>Buildings</InputLabel>
            <Select
              multiple
              value={selectedBuildings}
              onChange={(e) => setSelectedBuildings(e.target.value)}
              renderValue={(selected) =>
                selected
                  .map(
                    (id) =>
                      buildingList?.data?.property_buildings?.find(
                        (b) => b.id === id
                      )?.building_name
                  )
                  .join(", ")
              }
            >
              {buildingList?.data?.property_buildings?.map((building) => (
                <MenuItem key={building.id} value={building.id}>
                  <Checkbox checked={selectedBuildings.includes(building.id)} />
                  <ListItemText primary={building.building_name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Levels</InputLabel>
            <Select
              multiple
              value={selectedLevels}
              onChange={(e) => setSelectedLevels(e.target.value)}
              renderValue={(selected) =>
                selected
                  .map((id) => levelData.find((l) => l.id === id)?.name)
                  .join(", ")
              }
            >
              {levelData.map((level) => (
                <MenuItem key={level.id} value={level.id}>
                  <Checkbox checked={selectedLevels.includes(level.id)} />
                  <ListItemText primary={level.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box
          sx={{
            backgroundColor: "#fff",
            padding: 2,
            borderRadius: "0px 0px 6px 6px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 2,
              padding: 1,
              overflowX: "auto",
            }}
          >
            <Box sx={{ flex: "0 0 48%", minWidth: 300 }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                All Residents
              </Typography>
              <TableContainer
                component={Paper}
                sx={{
                  maxHeight: 400,
                  overflowY: "auto",
                  overflowX: "auto", // horizontal scroll for table
                }}
              >
                <Table size="small" stickyHeader>
                  <TableHead sx={{ background: "#F5F6FA" }}>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={areAllCurrentPageSelected}
                          onChange={handleAllResidentCheck}
                        />
                      </TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Email</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {pageLoading ? (
                      <TableRow>
                        <TableCell colSpan={3} align="center">
                          <CircularProgress size={24} />
                        </TableCell>
                      </TableRow>
                    ) : residentsData.length > 0 ? (
                      residentsData.map((row, index) => (
                        <TableRow
                          key={row.id}
                          sx={{ background: "#FFFFFF" }}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={selectedResidents.includes(row.user_id)}
                              onChange={() => handleResidentSelect(row)}
                            />
                          </TableCell>
                          <TableCell>{row?.user_details?.name}</TableCell>
                          <TableCell>{row?.user_details?.email}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center">
                          No residents found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <Box
                  sx={{
                    backgroundColor: "#FFFFFF",
                    borderTopStyle: "none !important",
                    // border: "1px solid #E5E7EB",
                    borderRadius: "0px 0px 8px 8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 2.5,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      sx={{
                        color: "#4D5761",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      Show :
                    </Typography>
                    <Box
                      onClick={(e) => setshowAnchorEl(e.currentTarget)}
                      sx={{
                        width: "95px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "1px solid #E5E7EB",
                        borderRadius: "6px",
                        ml: 2,
                        "&:hover": { cursor: "pointer" },
                      }}
                    >
                      <Typography
                        sx={{ fontSize: "15px" }}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        {rowsPerPage} rows{" "}
                        <NumberInputIcon style={{ paddingLeft: "5px" }} />
                      </Typography>
                    </Box>
                  </Box>
                  <Pagination
                    size="medium"
                    page={currentPage}
                    count={paginationData?.last_page}
                    onChange={(e, value) => setCurrentPage(value)}
                    shape="rounded"
                    renderItem={(item) => (
                      <PaginationItem
                        slots={{ previous: PreviousIcon, next: NextIcon }}
                        {...item}
                      />
                    )}
                  />
                </Box>
              </TableContainer>
            </Box>
            <Box sx={{ flex: "0 0 48%", minWidth: 300 }}>
              <Box
                sx={{
                  display: "flex",
                  mb: 2,
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6">Selected Residents</Typography>
                {selectedResidents.length > 0 && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleRemoveAllResidents}
                  >
                    Remove All Residents
                  </Button>
                )}
              </Box>

              <TableContainer
                component={Paper}
                sx={{
                  maxHeight: 400,
                  overflowY: "auto",
                  overflowX: "auto",
                }}
              >
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>Action</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Email</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedResidentList.length > 0 ? (
                      selectedResidentList.map((resident) => (
                        <TableRow key={resident.id}>
                          <TableCell>
                            <Button
                              onClick={() =>
                                handleRemoveResident(resident.user_id)
                              }
                              size="small"
                              color="error"
                            >
                              Remove
                            </Button>
                          </TableCell>
                          <TableCell>{resident?.user_details?.name}</TableCell>
                          <TableCell>{resident?.user_details?.email}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center">
                          No residents selected
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
          <Box sx={{ textAlign: "center", mt: 3 }}>
            {formDataErrors?.residents && (
              <ErrorTypography>{formDataErrors.residents}</ErrorTypography>
            )}
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            backgroundColor: "#fff",
            padding: 2,
            borderRadius: "6px",
          }}
        >
          <Button
            height="40px"
            sx={{
              padding: "20px",
              backgroundColor: "#E7EFF3",
              color: "#0E5E84",
              "&:hover": { backgroundColor: "#CFDFE6" },
            }}
            onClick={handleSubmit}
          >
            {id ? "Update" : "Create"}
          </Button>
        </Box>

        <Menu
          sx={{ m: 0.5 }}
          open={showOpen}
          anchorEl={showAnchorEl}
          onClose={() => setshowAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <MenuItem
            onClick={() => {
              setRowsPerPage(10);
              setshowAnchorEl(null);
            }}
          >
            <Typography>10 rows</Typography>
          </MenuItem>
          <MenuItem
            onClick={() => {
              setRowsPerPage(20);
              setshowAnchorEl(null);
            }}
          >
            <Typography>20 rows</Typography>
          </MenuItem>
          <MenuItem
            onClick={() => {
              setRowsPerPage(30);
              setshowAnchorEl(null);
            }}
          >
            <Typography>30 rows</Typography>
          </MenuItem>
          <MenuItem
            onClick={() => {
              setRowsPerPage(40);
              setshowAnchorEl(null);
            }}
          >
            <Typography>40 rows</Typography>
          </MenuItem>
          <MenuItem
            onClick={() => {
              setRowsPerPage(50);
              setshowAnchorEl(null);
            }}
          >
            <Typography>50 rows</Typography>
          </MenuItem>
        </Menu>
      </Box>
    </>
  );
};

export default CreateGroup;
